/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Decoding runs entirely in your browser; the token is never uploaded. Still, avoid pasting production tokens into any online tool.`)
};

const es_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La decodificación se ejecuta completamente en tu navegador; el token nunca se carga. Aún así, evita pegar tokens de producción en ninguna herramienta en línea.`)
};

const de_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Dekodierung läuft vollständig in Ihrem Browser; das Token wird niemals hochgeladen. Vermeiden Sie es dennoch, Produktions-Token in irgendein Online-Tool einzufügen.`)
};

const nl_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Decodering wordt volledig in uw browser uitgevoerd; het token wordt nooit geüpload. Vermijd echter om productietokens in een online hulpmiddel in te plakken.`)
};

const fr_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le décodage s'exécute entièrement dans votre navigateur ; le jeton n'est jamais téléchargé. Néanmoins, évitez de coller des jetons de production dans tout outil en ligne.`)
};

const it_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La decodifica viene eseguita interamente nel tuo browser; il token non viene mai caricato. Tuttavia, evita di incollare token di produzione in qualsiasi strumento online.`)
};

const pt_br2_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A decodificação ocorre inteiramente no seu navegador; o token nunca é enviado. Ainda assim, evite colar tokens de produção em qualquer ferramenta online.`)
};

const pt_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A descodificação funciona inteiramente no seu navegador; o token nunca é carregado. Mesmo assim, evite colar tokens de produção em qualquer ferramenta online.`)
};

const ja_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。デコーディングはブラウザで完全に実行されます。トークンはアップロードされません。ただし、本番環境のトークンをオンラインツールに貼り付けることは避けてください。`)
};

const zh_jw_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。解码完全在你的浏览器中进行，令牌不会被上传。不过，仍建议避免将生产环境的令牌粘贴到任何在线工具中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_faq3_a", locale)
	if (locale === "en") return en_jw_faq3_a(inputs)
	if (locale === "es") return es_jw_faq3_a(inputs)
	if (locale === "de") return de_jw_faq3_a(inputs)
	if (locale === "nl") return nl_jw_faq3_a(inputs)
	if (locale === "fr") return fr_jw_faq3_a(inputs)
	if (locale === "it") return it_jw_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_jw_faq3_a(inputs)
	if (locale === "pt") return pt_jw_faq3_a(inputs)
	if (locale === "ja") return ja_jw_faq3_a(inputs)
	return zh_jw_faq3_a(inputs)
};